// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from folder.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function FolderIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="M4.5 1a1.5 1.5 0 0 1 1.339.823l.056.125.018.052H14.5a1.5 1.5 0 0 1 1.473 1.215l.02.14L16 3.5v10a1.5 1.5 0 0 1-1.356 1.493L14.5 15h-13a1.5 1.5 0 0 1-1.493-1.356L0 13.5v-11a1.5 1.5 0 0 1 1.356-1.493L1.5 1h3ZM15 5H1v8.5a.5.5 0 0 0 .41.492L1.5 14h13a.5.5 0 0 0 .492-.41L15 13.5V5ZM4.5 2h-3a.5.5 0 0 0-.492.41L1 2.5V4h14v-.5a.5.5 0 0 0-.41-.492L14.5 3h-9a.5.5 0 0 1-.492-.41l-.016-.18a.5.5 0 0 0-.402-.402L4.5 2Z"
      />
    </svg>
  );
}
